<app-coming-soon title="Resource Status" icon="done"></app-coming-soon>
